// extracted by mini-css-extract-plugin
export default {"SmallContainer":"SmallBox_SmallContainer__jxJfm","Title":"SmallBox_Title__5XEoA","Text":"SmallBox_Text__5eNVR"};